/*
    This file encloses the apiFetcher util with implementation
    for loading animation and custom answers.
    Used for back compatibility with older API versions
*/

import { useState } from 'react';
import LoadingSpinner from 'contexts/loading-spinner/loading-spinner';
import { useApiFetcher } from 'utils/fetcher/ApiFetcher';
import useAuth from 'hooks/useAuth';






export const useApiGeneric = () => {
    const { logout } = useAuth();
    const ApiFetcher = useApiFetcher();
    const [isLoading, setIsLoading] = useState(false);
    const [loadingText, setLoadingText] = useState("Cargando información");
    const [loadingTextSubtitle, setLoadingTextSubtitle] = useState(null);

    

    //-------------------------------------
    const fetchAPI = async ({
        section, 
        action, 
        params, 
        OnLoaded,
        loadingMessage = "Cargando información",
        loadingMessageSubtitle = null,
        showSuccessNotification= false,
        showErrorNotification= false,
        showSuccessNotificationModal = false,
        showErrorNotificationModal = true
    }) => {
        setLoadingText(loadingMessage);
        setLoadingTextSubtitle(loadingMessageSubtitle);
        setIsLoading(true);

        // Iterate through params and append all values to formData
        const formData = new FormData();
        if (params) {
            Object.entries(params).forEach(([key, value]) => {
                // Skip null and undefined values to avoid sending string "null" to PHP
                if (value === null || value === undefined) {
                    return;
                }
                console.log("Appending to FormData:", key, value);
                if (typeof value === 'object' && !(value instanceof File) && !(value instanceof Blob)) {
                    // Serialize objects to JSON
                    formData.append(key, JSON.stringify(value));
                } else {
                    // Append primitive values and File/Blob directly
                    formData.append(key, value);
                }
            });
        }

        await ApiFetcher({
            type: 'POST',
            url: "?section="+section+"&action="+action,
            cache: 'no-store',
            data: formData,
            showSuccessNotification,
            showErrorNotification,
            showSuccessNotificationModal,
            showErrorNotificationModal,
            onSuccess: (payload)=>{
                setIsLoading(false);
                let success = true;
                if(OnLoaded) {
                    OnLoaded(success, payload);
                }
                return true;
            },
            onError: (responseData)=>{
                console.warn("API error:", responseData);
                setIsLoading(false);

                let success = false;
                if(OnLoaded) {
                    OnLoaded(success, responseData);
                }

                if(responseData === 'LOGOUT') {
                    // Si la respuesta es 'LOGOUT', llamar al logout del contexto de autenticación
                    logout();
                    return false;
                }

                return false;
            },
        });
    }







    //-------------------------------------
    const LoadingAnimation = ({ bgOpacity = 0.0 }) => {
        return (<>
            {isLoading && <LoadingSpinner text={loadingText} subtitle={loadingTextSubtitle} bgOpacity={bgOpacity}/>}
        </>);
    }

    return {
        fetchAPI,
        LoadingAnimation
    }
};
